import ls from 'helpers/local-storage';

const SUPPRESSION_KEY = 'sku_item_in_review_modal_suppressed_until';
const TWENTY_FOUR_HOURS = 24 * 60 * 60 * 1000;

export function suppressInReviewModal() {
  ls.set(SUPPRESSION_KEY, Date.now() + TWENTY_FOUR_HOURS);
}

export function shouldShowInReviewModal() {
  const suppressedUntil = ls.get(SUPPRESSION_KEY, null);
  return !suppressedUntil || Date.now() > suppressedUntil;
}
